var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlumbing = function SvgPlumbing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.64,
    height: 27.356
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Plumbing Icon"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 350",
    d: "M21.452 7.951a6.137 6.137 0 0 0-4.47-3.106V3.136h4.133v-1.9h-4.133V0H15.03v1.231h-4.133v1.9h4.133v1.713a6.137 6.137 0 0 0-4.47 3.106H.004v5.7h10.557a6.251 6.251 0 0 0 10.891 0h1.852v2.33h5.84V7.951Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 351",
    d: "M28.728 21.651a9.811 9.811 0 0 0-1.086-1.263l-.479-.455-.479.455a9.807 9.807 0 0 0-1.081 1.263 5.128 5.128 0 0 0-1.133 2.909 2.694 2.694 0 1 0 5.385 0 5.127 5.127 0 0 0-1.127-2.909Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 589",
    d: "M21.138 16.832h9.502v2.334h-9.502z"
  }))));
};
export default SvgPlumbing;